import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Icon from 'presentations/views/components/atoms/Icon';
import { fontSize } from 'presentations/views/styles';

export interface Props {
  expanded: boolean;
  onChange?: (event: object, expanded: boolean) => void;
  summary: ReactNode;
  details: ReactNode;
  timeout?: number;
  hiddenExpandIcon?: boolean;
}

export default function Component(props: Props) {
  return (
    <Container>
      <Accordion
        TransitionProps={{ timeout: props.timeout }}
        square
        expanded={props.expanded}
        onChange={props.onChange}
      >
        <AccordionSummary>
          {props.summary}
          {!props.hiddenExpandIcon && (
            <ExpandIcon
              name={props.expanded ? 'expand_less' : 'expand_more'}
              size={fontSize(20)}
            />
          )}
        </AccordionSummary>
        <AccordionDetails>{props.details}</AccordionDetails>
      </Accordion>
    </Container>
  );
}

const Container = styled.div`
  .MuiAccordion-root {
    box-shadow: none;
    background-color: transparent;
    &:before {
      display: none;
    }
    &:not(:last-of-type) {
      border-bottom: none;
    }
  }
  .MuiAccordion-root.Mui-expanded {
    margin: auto;
  }
  .MuiAccordionSummary-root {
    width: 100%;
    min-height: initial;
    margin: 0;
    padding: 0;
  }
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: initial;
  }
  .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
  }
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
  .MuiAccordionDetails-root {
    flex-direction: column;
    padding: 0;
  }
`;
const ExpandIcon = styled(Icon)`
  min-width: 20px;
  min-height: 20px;
`;
